import { render, staticRenderFns } from "./CustomerListDetail.vue?vue&type=template&id=7158f679&scoped=true"
import script from "./CustomerListDetail.vue?vue&type=script&lang=js"
export * from "./CustomerListDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerListDetail.vue?vue&type=style&index=0&id=7158f679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158f679",
  null
  
)

export default component.exports